package com.schoolconnect.app.feature.parentnotes

import androidx.compose.ui.graphics.Color
import com.schoolconnect.app.designsystem.AppNavy
import com.schoolconnect.app.designsystem.AppSuccess
import com.schoolconnect.app.designsystem.AppWarning

internal fun parentNoteStatusColor(status: String): Color = when (status.trim().uppercase().replace('_', ' ')) {
    "CLOSED", "ACTIVE" -> AppSuccess
    "UNREAD", "PENDING TEACHER", "PENDING PARENT", "AWAITING YOUR REPLY" -> AppWarning
    else -> AppNavy
}
